import { createTheme } from '@mui/material/styles'

import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

// 旧 kakeru UI 用 MUI theme. LegacyIndexPage を本 theme で wrap し、 canonical Notion
// theme の影響 (= typography / spacing / palette / radius / component override) を遮断する.
export const legacyTheme = createTheme({
  typography: {
    fontFamily:
      "'Noto Sans JP', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    button: { textTransform: 'none' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
        sizeSmall: {
          fontSize: '0.75rem',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
        },
      },
    },
  },
  palette: {
    primary: {
      main: colorTokens.blue[600],
      dark: colorTokens.blue[700],
      light: colorTokens.blue[500],
      contrastText: colorTokens.background.paper,
    },
    secondary: {
      main: colorTokens.grey[500],
      dark: colorTokens.grey[700],
      light: colorTokens.grey[200],
    },
    background: {
      default: colorTokens.background.page,
      paper: colorTokens.background.paper,
    },
    text: colorTokens.text,
    grey: colorTokens.grey,
    action: {
      selected: colorTokens.special.selected,
      selectedOpacity: 0.08,
      hover: 'rgba(25, 118, 210, 0.04)',
      hoverOpacity: 0.04,
      focus: 'rgba(25, 118, 210, 0.08)',
      focusOpacity: 0.08,
      disabled: colorTokens.grey[300],
      disabledBackground: colorTokens.grey[100],
    },
    success: {
      main: colorTokens.status.success,
      light: colorTokens.status.successLight,
    },
    error: {
      main: colorTokens.status.error,
      light: colorTokens.status.errorLight,
    },
    warning: {
      main: colorTokens.status.error,
      light: colorTokens.status.warningLight,
    },
    divider: colorTokens.border.light,
  },
})
